import { render, staticRenderFns } from "./AsignacionSeleccionTab.vue?vue&type=template&id=f6963d54&"
import script from "./AsignacionSeleccionTab.vue?vue&type=script&lang=js&"
export * from "./AsignacionSeleccionTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports